export interface DemoFlag {
    flag: string;
    isEnabled: boolean;
}

export interface DemoFlagGroups {
    overriddenFlags: DemoFlag[];
    firmFlags: DemoFlag[];
    otherFlags: DemoFlag[];
}

/** On org-level pages pass the firm's overrides as `overrides` and none as `organizationOverrides`. */
export const groupDemoFlags = ({
    baseFlagValues,
    overrides,
    organizationOverrides,
    search,
}: {
    baseFlagValues: Record<string, boolean>;
    overrides: Record<string, boolean>;
    organizationOverrides: Record<string, boolean>;
    search: string;
}): DemoFlagGroups => {
    const query = search.trim().toLowerCase();
    const flags = [
        ...new Set([
            ...Object.keys(baseFlagValues),
            ...Object.keys(organizationOverrides),
            ...Object.keys(overrides),
        ]),
    ]
        .filter((flag) => flag.includes(query))
        .sort();
    const groups: DemoFlagGroups = {
        overriddenFlags: [],
        firmFlags: [],
        otherFlags: [],
    };

    for (const flag of flags) {
        if (flag in overrides) {
            groups.overriddenFlags.push({ flag, isEnabled: overrides[flag] });
        } else if (flag in organizationOverrides) {
            groups.firmFlags.push({
                flag,
                isEnabled: organizationOverrides[flag],
            });
        } else {
            groups.otherFlags.push({
                flag,
                isEnabled: baseFlagValues[flag] ?? false,
            });
        }
    }

    return groups;
};
